import { Container } from "../components/container/container";
import { Header } from "../components/header/header";
import { Card, CardContent } from "@mui/material";
import { PropsWithChildren, useEffect } from "react";
import classes from './auth-layout.module.scss';
import { usePageBackgroundContext } from "../components/context/page-background-context";

export type AuthLayoutProps = PropsWithChildren<{}>;

export const AuthLayout = ({ children }: AuthLayoutProps) => {
    const pageBackground = usePageBackgroundContext();

    useEffect(() => {
        pageBackground.setColor('var(--theme-palette-background-accent)');
        return () => {
            pageBackground.setColor(null);
        }
    }, [])

    return <Container padded className={ classes.root }>
        <Header showUserMenu={false} showLanguageSwitcher={false}/>
        <div className={ classes.contentWrapper }>
            <Card >
                <CardContent>
                    { children }
                </CardContent>
            </Card>
        </div>
    </Container>
}
